import { initializeApp } from 'firebase/app';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDju1kLGKNEK2guFkhD0jyNNszfdA1tF_o",
  authDomain: "crosswordgen-1eb07.firebaseapp.com",
  projectId: "crosswordgen-1eb07",
  storageBucket: "crosswordgen-1eb07.firebasestorage.app",
  messagingSenderId: "852537024728",
  appId: "1:852537024728:web:b12f97486e7e3f40af37ad",
  measurementId: "G-BKH7PYH1FG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Functions with explicit region
export const functions = getFunctions(app, 'us-central1');

// Connect to emulator in development
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log('Connected to Firebase Functions emulator');
}

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6Lf0QjQrAAAAAP5cpTI7KcgiYuKmIH7iB9BX3lhE'),
  isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
});

export default app; 